'use client';

import { ArrowSquareOut } from '@liveauctioneers/hammer-ui-core/icons';
import { AtgSellerPortalLogo } from '../AtgSellerPortalLogo/AtgSellerPortalLogo';
import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useRouter } from '@/navigation';
import React from 'react';

type LoginHeaderProps = {
    showBuyerLogin?: boolean;
};

export const LoginHeader = ({ showBuyerLogin = true }: LoginHeaderProps) => {
    const { push } = useRouter();
    return (
        <header
            className="flex w-full justify-between p-xs"
            data-testid="login-header"
        >
            <div className="m-xs">
                <AtgSellerPortalLogo href="https://www.proxibid.com/" />
            </div>
            {showBuyerLogin && (
                <Button
                    aria-label="Buyer Login"
                    data-testid="buyer-login-button"
                    iconRight={ArrowSquareOut}
                    onClick={() => push('https://www.proxibid.com/asp/LoginBidder.asp')}
                    size="sm"
                    style="neutral"
                    variant="transparent"
                >
                    Buyer Login
                </Button>
            )}
        </header>
    );
};

LoginHeader.displayName = 'LoginHeader';
